import React, { useEffect, useState } from 'react';

function BarBillingInfo({ token, selectedPropertyId }) {
  const [form, setForm] = useState({
    billing_name: '',
    billing_address: '',
    city: '',
    state: '',
    country: '',
    gst_number: ''
  });
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const propertyId = String(selectedPropertyId || localStorage.getItem('selectedPropertyId') || '').trim();
  const headers = (extra = {}) => ({ Authorization: `Bearer ${token}`, 'x-property-id': propertyId, ...extra });

  const loadBillingInfo = async () => {
    if (!propertyId) return;
    setError('');
    try {
      const res = await fetch('/api/bar-billing-info', { headers: headers() });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) return setError(data.error || 'Failed to load billing info');
      setForm({
        billing_name: data.billing_name || '',
        billing_address: data.billing_address || '',
        city: data.city || '',
        state: data.state || '',
        country: data.country || '',
        gst_number: data.gst_number || ''
      });
    } catch {
      setError('Network error while loading billing info');
    }
  };

  useEffect(() => {
    loadBillingInfo();
  }, [token, selectedPropertyId]);

  const saveBillingInfo = async () => {
    if (!propertyId) return setError('Select property first from Hotel Config');
    setError('');
    setMessage('');
    try {
      const res = await fetch('/api/bar-billing-info', {
        method: 'PUT',
        headers: headers({ 'Content-Type': 'application/json' }),
        body: JSON.stringify(form)
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) return setError(data.error || 'Save failed');
      setMessage('Billing info saved');
    } catch {
      setError('Network error while saving billing info');
    }
  };

  const input = { padding: '0.7rem', border: '1px solid #dcdde1', borderRadius: '6px' };
  const btn = { padding: '0.6rem 1rem', border: 'none', borderRadius: '6px', cursor: 'pointer' };

  return (
    <div className="page-shell">
      <h2 style={{ color: 'var(--theme-primary-dark)' }}>Billing Info</h2>
      {error ? <div className="error-banner">{error}</div> : null}
      {message ? <div className="success-banner">{message}</div> : null}

      <div className="filter-bar" style={{ maxWidth: '900px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '0.7rem' }}>
          <input placeholder="Billing Name" value={form.billing_name} onChange={(e) => setForm({ ...form, billing_name: e.target.value })} style={input} />
          <input placeholder="GST Number" value={form.gst_number} onChange={(e) => setForm({ ...form, gst_number: e.target.value })} style={input} />
          <input placeholder="City" value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} style={input} />
          <input placeholder="State" value={form.state} onChange={(e) => setForm({ ...form, state: e.target.value })} style={input} />
          <input placeholder="Country" value={form.country} onChange={(e) => setForm({ ...form, country: e.target.value })} style={input} />
          <textarea placeholder="Billing Address" value={form.billing_address} onChange={(e) => setForm({ ...form, billing_address: e.target.value })} style={{ ...input, gridColumn: '1 / -1', minHeight: '80px' }} />
        </div>
        <div style={{ marginTop: '0.8rem' }}>
          <button type="button" onClick={saveBillingInfo} className="btn-primary" style={btn}>Save Billing Info</button>
        </div>
      </div>
    </div>
  );
}

export default BarBillingInfo;
